module.exports = __webpack_public_path__ + "static/media/screenshot(45).6a7c0ba0.jpg";